import React, { useState } from "react";
import { Input } from "@mui/material";
import { useSelector } from "react-redux";

import { ButtonComp } from "components";
import { selectIsDisabled } from "slices";

const ShowQuestion = ({ question, objKey, customQuestions, setCustomQuestions }) => {
  const [answer, setAnswer] = useState("");

  const isDisabledOptions = useSelector(selectIsDisabled);

  const handleChange = (value) => {
    if (question.type === "boolean" && answer === value) {
      setAnswer("");

      setCustomQuestions({
        ...customQuestions,
        [objKey]: {
          question: question.question,
          answer: "",
        },
      });

      return;
    }

    setAnswer(value);

    setCustomQuestions({
      ...customQuestions,
      [objKey]: {
        question: question.question,
        answer: question.type === "boolean" ? `${value === "Yes"}` : value,
      },
    });
  };

  return (
    <div className="hayley-w-full">
      <div className="hayley-flex hayley-items-center">
        <span className="hayley-mr-4 !hayley-text-sm">
          {question.question}
          {question.isRequired ? " *" : null}
        </span>
        {question.type === "boolean" ? (
          <div data-testid="custom-form-question-boolean" className="hayley-flex hayley-w-max hayley-space-x-2">
            {["Yes", "No"].map((v, i) => (
              <ButtonComp
                key={i}
                className={`hayley-m-0 hayley-p-0 !hayley-px-[2px] !hayley-py-[4px] ${v === answer ? "hayley-text-black" : "hayley-text-custom-4"}`}
                selected={v === answer}
                label={v}
                onClick={() => handleChange(v)}
                disabled={isDisabledOptions}
              />
            ))}
          </div>
        ) : null}
      </div>
      {question.type === "text" ? (
        <Input
          data-testid={`custom-form-question-txt`}
          className="hayley-mt-1 hayley-h-10 hayley-w-full hayley-p-[10px] hayley-text-sm hayley-text-[#333] hayley-outline-none"
          style={{ border: "1px solid #dadada" }}
          value={answer}
          onChange={(e) => handleChange(e.target.value)}
          disabled={isDisabledOptions}
          type={"text"}
          disableUnderline
          aria-label={question.question}
        />
      ) : null}
    </div>
  );
};

export default ShowQuestion;
